import React from 'react';
import moment from 'moment';
import { Weekdays } from '../Common';
import { FormGroup, Input } from 'reactstrap';
import {
    FormLabel,
    ValidationErrorMessage,
} from '../common/forms/FormElements';
import Select from 'react-select';
import { MaxResourceCount } from './LongTermSchedule';

export default class ReleasedLongTermScheduleDetails extends React.Component {
    getDayName = () => {
        const { eventDate } = this.props;

        if (!eventDate) {
            return null;
        }

        return Weekdays[moment(eventDate).day()].name.toLowerCase();
    };

    getLowboyResourcesForDay = () => {
        const { job, eventDate } = this.props;

        if (!job || !job.lowboyResources) {
            return [];
        }

        return job.lowboyResources.filter((lr) =>
            moment(lr.date).isSame(eventDate, 'day')
        );
    };

    render() {
        const {
            longTermSchedule,
            cancelWorkflowEnabled,
            isReleased,
            isCancelled,
            applicationGroups,
            equipmentGroups,
            onChange,
            onEquipmentGroupChange,
            arcGisLocations,
            onArcGisLocationChange,
            onJobOverrideArcGisLocationChange,
            eventDate,
            jobOverride,
        } = this.props;

        if (
            cancelWorkflowEnabled ||
            (longTermSchedule.isPublished && !isReleased)
        ) {
            return null;
        }

        const applicationGroup = applicationGroups.find(
            (ag) =>
                longTermSchedule.scheduleApplicationGroupCount
                    .applicationGroupId == ag.id
        );

        const anyLocationsDefined = Boolean(
            arcGisLocations && arcGisLocations.length > 0
        );

        const shouldBeDisabled =
            isReleased ||
            isCancelled ||
            moment(eventDate).isBefore(new Date(), 'day');

        return (
            <div className="d-flex justify-content-between lts-released-details">
                {!anyLocationsDefined && !longTermSchedule.isPublished && (
                    <FormGroup className="w-14">
                        <FormLabel text="Road Name" required={true} />
                        <Input
                            id="longTermSchedule.roadName"
                            name="longTermSchedule.roadName"
                            value={longTermSchedule.roadName}
                            onChange={onChange}
                            type="text"
                            required={true}
                            disabled={longTermSchedule.isPublished}
                            maxLength={100}
                            valid={Boolean(
                                longTermSchedule.roadName &&
                                longTermSchedule.roadName.trim().length > 0
                            )}
                        />
                        <ValidationErrorMessage>
                            Road Name is required.
                        </ValidationErrorMessage>
                    </FormGroup>
                )}

                {!anyLocationsDefined && longTermSchedule.isPublished && (
                    <FormGroup className="w-14">
                        <FormLabel text="Road Name" required={true} />
                        <Input
                            id="jobOverride.roadName"
                            name="jobOverride.roadName"
                            value={jobOverride.roadName}
                            onChange={onChange}
                            type="text"
                            maxLength={100}
                            valid={Boolean(
                                longTermSchedule.roadName &&
                                longTermSchedule.roadName.trim().length > 0
                            )}
                            placeholder={longTermSchedule.roadName}
                        />
                        <ValidationErrorMessage>
                            Road Name is required.
                        </ValidationErrorMessage>
                    </FormGroup>
                )}

                {anyLocationsDefined && !longTermSchedule.isPublished && (
                    <FormGroup className="w-25">
                        <FormLabel text="Location" required />
                        <Select
                            id="longTermSchedule.arcGisLocationId"
                            name="longTermSchedule.arcGisLocationId"
                            options={arcGisLocations}
                            getOptionValue={(agl) => agl.id}
                            getOptionLabel={(agl) =>
                                agl.isActive
                                    ? agl.addrLoc
                                    : `[INACTIVE] ${agl.addrLoc}`
                            }
                            value={
                                arcGisLocations.filter(
                                    (agl) =>
                                        agl.id ==
                                        longTermSchedule.arcGisLocationId
                                ) ?? ''
                            }
                            onChange={onArcGisLocationChange}
                            menuPlacement="top"
                            isDisabled={shouldBeDisabled}
                        />
                    </FormGroup>
                )}

                {anyLocationsDefined && longTermSchedule.isPublished && (
                    <FormGroup className="w-25">
                        <FormLabel text="Location" required />
                        <Select
                            id="jobOverride.arcGisLocationId"
                            name="jobOverride.arcGisLocationId"
                            options={arcGisLocations}
                            getOptionValue={(agl) => agl.id}
                            getOptionLabel={(agl) =>
                                agl.isActive
                                    ? agl.addrLoc
                                    : `[INACTIVE] ${agl.addrLoc}`
                            }
                            value={
                                arcGisLocations.filter(
                                    (agl) =>
                                        (jobOverride &&
                                            jobOverride.arcGisLocationId &&
                                            agl.id ==
                                                jobOverride.arcGisLocationId) ||
                                        ((!jobOverride ||
                                            !jobOverride.arcGisLocationId) &&
                                            agl.id ==
                                                longTermSchedule.arcGisLocationId)
                                ) ?? ''
                            }
                            onChange={onJobOverrideArcGisLocationChange}
                            menuPlacement="top"
                            isDisabled={shouldBeDisabled}
                        />
                    </FormGroup>
                )}

                <FormGroup className="w-14">
                    <FormLabel text={applicationGroup.groupName} />
                    <Input
                        id="longTermSchedule.scheduleApplicationGroupCount.count"
                        name="longTermSchedule.scheduleApplicationGroupCount.count"
                        value={
                            longTermSchedule.scheduleApplicationGroupCount.count
                        }
                        onChange={onChange}
                        type="number"
                        disabled={shouldBeDisabled}
                        valid={Boolean(
                            !longTermSchedule.scheduleApplicationGroupCount
                                .count ||
                            (longTermSchedule.scheduleApplicationGroupCount
                                .count > 0 &&
                                longTermSchedule.scheduleApplicationGroupCount
                                    .count < MaxResourceCount)
                        )}
                        max={MaxResourceCount}
                        inputMode="numeric"
                    />
                    <ValidationErrorMessage>
                        Count should be greater than zero and less than or equal
                        to {MaxResourceCount}.
                    </ValidationErrorMessage>
                </FormGroup>

                {longTermSchedule.scheduleEquipmentGroupCounts.map(
                    (segc, i) => {
                        const equipmentGroup = equipmentGroups.find(
                            (eg) => eg.id == segc.equipmentGroupId
                        );

                        const indexLookup = `longTermSchedule.scheduleEquipmentGroupCounts[${i}].count`;
                        const equipmentLabel = equipmentGroup.isTruck
                            ? `Brokered ${equipmentGroup.name}`
                            : equipmentGroup.name;

                        return (
                            <FormGroup
                                key={segc.equipmentGroupId}
                                className="w-14"
                            >
                                <FormLabel text={equipmentLabel} />

                                <Input
                                    id={indexLookup}
                                    name={indexLookup}
                                    value={segc.count}
                                    onChange={onEquipmentGroupChange}
                                    type="number"
                                    disabled={shouldBeDisabled}
                                    invalid={Boolean(
                                        segc.count === '' ||
                                        segc.count < 0 ||
                                        segc.count > MaxResourceCount
                                    )}
                                    max={MaxResourceCount}
                                    min={0}
                                    inputMode="numeric"
                                />
                                <ValidationErrorMessage>
                                    Count should be greater than zero and less
                                    than or equal to {MaxResourceCount}.
                                </ValidationErrorMessage>
                            </FormGroup>
                        );
                    }
                )}
            </div>
        );
    }
}
